import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsArray, IsBoolean, IsDateString, IsDefined, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
import { OrderStatusEnum } from '../enum';
import { InsightsOrderSubFiltersPagerDto } from './InsightsOrderSubFiltersPagerDto';
export class OrderFindConditionsDto {
}
__decorate([
    ApiPropertyOptional({ enum: OrderStatusEnum, isArray: true }),
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], OrderFindConditionsDto.prototype, "statuses", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean }),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], OrderFindConditionsDto.prototype, "isASAP", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true }),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], OrderFindConditionsDto.prototype, "orderIds", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true }),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], OrderFindConditionsDto.prototype, "storeIds", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true }),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], OrderFindConditionsDto.prototype, "userIds", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, isArray: true }),
    IsOptional(),
    IsArray(),
    __metadata("design:type", Array)
], OrderFindConditionsDto.prototype, "orderNumbers", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional(),
    IsDateString(),
    __metadata("design:type", String)
], OrderFindConditionsDto.prototype, "startDate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsOptional(),
    IsDateString(),
    __metadata("design:type", String)
], OrderFindConditionsDto.prototype, "endDate", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], OrderFindConditionsDto.prototype, "customer", void 0);
__decorate([
    ApiProperty({ type: () => InsightsOrderSubFiltersPagerDto }),
    IsDefined(),
    ValidateNested(),
    Type(() => InsightsOrderSubFiltersPagerDto),
    __metadata("design:type", InsightsOrderSubFiltersPagerDto)
], OrderFindConditionsDto.prototype, "pager", void 0);
//# sourceMappingURL=OrderFindConditionsDto.js.map